import React from 'react';
import { Box, Typography } from '@mui/material';

const PageHeader = ({ title, subtitle, action }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: 2,
      mb: 3,
      flexDirection: { xs: 'column', sm: 'row' },
    }}
  >
    <Box>
      <Typography variant="h4" fontWeight={700} color="text.primary">{title}</Typography>
      {subtitle && (
        <Typography variant="body2" color="text.secondary" mt={0.5}>{subtitle}</Typography>
      )}
    </Box>
    {/* No flexShrink:0 here on purpose — a long action row (several
        buttons) needs to be able to wrap onto its own line(s) once it no
        longer fits beside the title, instead of forcing the whole header
        wider than the viewport. */}
    {action && (
      <Box sx={{ mt: { xs: 2, sm: 0 }, maxWidth: '100%' }}>{action}</Box>
    )}
  </Box>
);

export default PageHeader;
